/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiIdentityEmailconsentGet } from '../fn/email-consent/api-identity-emailconsent-get';
import { ApiIdentityEmailconsentGet$Params } from '../fn/email-consent/api-identity-emailconsent-get';
import { apiIdentityEmailconsentGet$Plain } from '../fn/email-consent/api-identity-emailconsent-get-plain';
import { ApiIdentityEmailconsentGet$Plain$Params } from '../fn/email-consent/api-identity-emailconsent-get-plain';
import { apiIdentityEmailconsentPut } from '../fn/email-consent/api-identity-emailconsent-put';
import { ApiIdentityEmailconsentPut$Params } from '../fn/email-consent/api-identity-emailconsent-put';
import { apiIdentityEmailconsentPut$Plain } from '../fn/email-consent/api-identity-emailconsent-put-plain';
import { ApiIdentityEmailconsentPut$Plain$Params } from '../fn/email-consent/api-identity-emailconsent-put-plain';
import { apiIdentityEmailconsentUpdateAllEmailConsentsGet } from '../fn/email-consent/api-identity-emailconsent-update-all-email-consents-get';
import { ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Params } from '../fn/email-consent/api-identity-emailconsent-update-all-email-consents-get';
import { apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain } from '../fn/email-consent/api-identity-emailconsent-update-all-email-consents-get-plain';
import { ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain$Params } from '../fn/email-consent/api-identity-emailconsent-update-all-email-consents-get-plain';
import { EmailConsentCustomerDto } from '../models/email-consent-customer-dto';
import { Response } from '../models/response';

@Injectable({ providedIn: 'root' })
export class EmailConsentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiIdentityEmailconsentGet()` */
  static readonly ApiIdentityEmailconsentGetPath = '/api/identity/emailconsent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityEmailconsentGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentGet$Plain$Response(params?: ApiIdentityEmailconsentGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailConsentCustomerDto>> {
    return apiIdentityEmailconsentGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityEmailconsentGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentGet$Plain(params?: ApiIdentityEmailconsentGet$Plain$Params, context?: HttpContext): Observable<EmailConsentCustomerDto> {
    return this.apiIdentityEmailconsentGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailConsentCustomerDto>): EmailConsentCustomerDto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityEmailconsentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentGet$Response(params?: ApiIdentityEmailconsentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<EmailConsentCustomerDto>> {
    return apiIdentityEmailconsentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityEmailconsentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentGet(params?: ApiIdentityEmailconsentGet$Params, context?: HttpContext): Observable<EmailConsentCustomerDto> {
    return this.apiIdentityEmailconsentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<EmailConsentCustomerDto>): EmailConsentCustomerDto => r.body)
    );
  }

  /** Path part for operation `apiIdentityEmailconsentPut()` */
  static readonly ApiIdentityEmailconsentPutPath = '/api/identity/emailconsent';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityEmailconsentPut$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityEmailconsentPut$Plain$Response(params?: ApiIdentityEmailconsentPut$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityEmailconsentPut$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityEmailconsentPut$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityEmailconsentPut$Plain(params?: ApiIdentityEmailconsentPut$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityEmailconsentPut$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityEmailconsentPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityEmailconsentPut$Response(params?: ApiIdentityEmailconsentPut$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityEmailconsentPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityEmailconsentPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdentityEmailconsentPut(params?: ApiIdentityEmailconsentPut$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityEmailconsentPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /** Path part for operation `apiIdentityEmailconsentUpdateAllEmailConsentsGet()` */
  static readonly ApiIdentityEmailconsentUpdateAllEmailConsentsGetPath = '/api/identity/emailconsent/UpdateAllEmailConsents';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain$Response(params?: ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain(params?: ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityEmailconsentUpdateAllEmailConsentsGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdentityEmailconsentUpdateAllEmailConsentsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentUpdateAllEmailConsentsGet$Response(params?: ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Response>> {
    return apiIdentityEmailconsentUpdateAllEmailConsentsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdentityEmailconsentUpdateAllEmailConsentsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdentityEmailconsentUpdateAllEmailConsentsGet(params?: ApiIdentityEmailconsentUpdateAllEmailConsentsGet$Params, context?: HttpContext): Observable<Response> {
    return this.apiIdentityEmailconsentUpdateAllEmailConsentsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Response>): Response => r.body)
    );
  }

}
